module.exports = __webpack_public_path__ + "media/images/jobs/jobs-writer-zh-hant-9ef828a201a21ca8b5ea482823a3d1c4.jpg";